import { Button, Tooltip } from '@bancobarigui/barihaus';
import { ReactNode } from 'react';

interface ActionButtonProps {
  icon: ReactNode;
  tooltip: string;
  isActive?: boolean;
  onClick: () => void;
  variant?: 'danger' | 'default';
}

export function ActionButton({
  icon,
  tooltip,
  isActive = false,
  onClick,
  variant = 'default',
}: ActionButtonProps) {
  const getClassName = () => {
    if (variant === 'danger') {
      return 'hover:bg-red-50 hover:text-red-500 rounded-full';
    }

    if (isActive) {
      return 'bg-blue-700 hover:bg-blue-800 text-white rounded-full';
    }

    return 'rounded-full hover:bg-gray-100';
  };

  return (
    <Tooltip title={tooltip}>
      <Button
        type={isActive ? 'default' : 'text'}
        size="small"
        className={getClassName()}
        icon={icon}
        onClick={onClick}
        danger={variant === 'danger'}
        children={undefined}
      />
    </Tooltip>
  );
}
